import React from "react";
import classes from "./styles/style.module.css";

function ProgressBar({ progress, progressColor, height, prgoressText }) {
  return (
    <div className={classes.progressBarContainer} style={{ height: height }}>
      <div
        style={{
          width: `${progress}%`,
          height: "100%",
          borderRadius: "100px",
          background: progressColor,
          transition: "width 0.5s ease-in-out",
        }}
      >
        <div className="d-flex justify-content-end">
          <p className={classes.progressText}>{prgoressText}</p>
        </div>
      </div>
    </div>
  );
}

export default ProgressBar;
